import {Background, Container, SubWrapper, Text, Wrap} from "./styled";
import {SectionSubTitle} from "../../CummonComponents/SectionSubTitle/SectionSubTitle";
import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {ParallaxBackground} from "../../CummonComponents/ParallaxBackground/ParallaxBackground";
import {useImageUrl} from "../../../queries";

export const About = ({data}) => {
    const aboutTitle = data?.about_title || '';
    const aboutDescription = data?.about_description || '';
    const aboutContent = data?.about_content || '';
    const aboutImageUrl = useImageUrl(data?.about_background || "");

    return (
        <Container>
            <ParallaxBackground
                imageUrl={aboutImageUrl || "./img/10-ppa-images.jpg"}
                speedFactor={-0.2}
                height={'150%'}
                back={true}
            />
            <Background>
                <Wrap>
                    <SectionTitle>{aboutTitle}</SectionTitle>
                    <SectionSubTitle>
                        <SubWrapper>
                            {aboutDescription}
                        </SubWrapper>
                    </SectionSubTitle>
                    {aboutContent && <Text>{aboutContent}</Text>}
                </Wrap>
            </Background>
        </Container>
    )
}
